import BackofficeController from 'backoffice_controller';

export default class extends BackofficeController {
  static targets = ['hiddenInput'];

  connect() {}

  select(e) {
    this._uncheckAll();
    this._removeDefaultClass(e.target);

    const selected = [...this.hiddenInputTargets].find((input) => input.value === e.target.dataset.status);
    selected.checked = 'checked';
  }

  _uncheckAll() {
    [...this.hiddenInputTargets].forEach((item) => item.checked = '');
  }

  _removeDefaultClass(target) {
    if (target.dataset.status !== 'undefined') {
      this.element.querySelector('.default')?.classList.remove('default');
    } else {
      [...this.element.querySelectorAll('label')].find((item) => {
        return item.dataset.status === target.dataset.status;
      })?.classList.add('default');
    }
  }
}
